// Kid Rewards — thin wrapper around the shared RewardsView with
// readOnly mode on, so kids see the catalog + can redeem but can't
// create or archive entries. Stars hero stays prominent at the top.

import { RewardsView } from "../chores/rewards";

interface KidRewardsProps {
  notify: (msg: string) => void;
}

export function KidRewardsView({ notify }: KidRewardsProps) {
  return (
    <div className="kid-rewards-wrap">
      <RewardsView notify={notify} readOnly />
    </div>
  );
}
